import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Footer from "../components/footer";
import NavigationBar from "../components/navigationbar";
import payzakat from "../assets/payzakat.png";
import zelle from "../assets/zelle.png";
import venmo from "../assets/venmo.png";
import paypal from "../assets/paypal.png";
import madinaapps from "../assets/madinaapps.png";
import feelingblessed from "../assets/feelingblessed.png";
import checks from "../assets/checks.png";
import benevity from "../assets/benevity.png";
import ZakatChart from "../components/zakatchart";
import austincares from "../assets/austincares.png";


const paymentMethods = [
    { name: "Zelle", description: <>accountant@austinmosque.org<br/>Please specify zakat or sadaqah</>, icon: zelle, link: null },
    { name: "Venmo", description: <>@icgamanor<br/>Please specify zakat or sadaqah</>, icon: venmo, link: null },
    {
        name: "Checks",
        description: (
            <>
                Make checks out to ICGA <br />
                Mail to: 5110 Manor Rd, Austin TX 78723
            </>
        ),
        icon: checks, link: null
    },
    { name: "PayPal", description: <>Donate to Islamic Center of Greater Austin<br/>Please specify zakat or sadaqah</>, icon: paypal, link: "https://www.paypal.com/donate/?hosted_button_id=AYG9M9J6LGKLC" },
    { name: "Feeling Blessed", description: "Donate via Feeling Blessed", icon: feelingblessed, link: "https://www.feelingblessed.org/donate/islamic-center-of-greater-austin-manor" },
    { name: "Madina Apps", description: "Support us through Madina Apps", icon: madinaapps, link: "https://payments.madinaapps.com/ICGA" },
    {
        name: "Company Matching (Benevity)",
        description: (
            <>
                ICGA is a registered organization with several company matching programs.
                Following is a list of companies that match donations to ICGA. Please consult your HR Department for additional details. <br />
                Google, Apple, Visa, Intel, etc.
            </>
        ),
        icon: benevity,
        link: "https://causes.benevity.org/user"
    },
    {
    
        name: "Company Matching (Austin Cares)",
        description: (
            <>
                512 Brothers & Sisters is registered with several company matching programs.
                IBM, Microsoft, Dell, etc.  <br />
                512 Brothers & Sisters <br />
                DBA: AustinCares <br />
                EI Number: 47-0996261 <br />
                11331 North Lamar BLVD Suite D2 Austin TX, 78753

            </>
        ),
        icon: austincares,
        link: "https://causes.benevity.org/user"
    },
    {
        name: "Stock Donations",
        description: (
            <>
                You can pay zakat by donating stocks through Nueces Mosque. Make sure to select Zakat in the form. 
            </>
        ),
        icon: 'https://static.tgbwidget.com/organization_logo/cffef258-bb84-455c-9590-980e70d6edae.png',
        link: "https://www.nuecesmosque.com/reconstruction#donate"
    }
];

export const PayZakat = () => {
    return (
        <div className="home-page">
            <NavigationBar />
            <div
                className="position-relative"
                style={{
                    overflow: "hidden",
                    background: "linear-gradient(to right, #b8cfbd 0%, white 100%)",
                }}
            >
                <Row className="px-5 my-3 mb-2">
                    <h4 className="text-center my-0 py-0 mb-2">Greater Austin Muslim Relief Committee</h4>

                    {/* Left Side: Title + Image */}
                    <Col
                        className="d-flex flex-column justify-content-center  px-5 align-items-center text-center"
                        md={5}
                    >
                        <Container className="px-5">
                            <h1 className="fw-bold">Pay Zakat Locally</h1>
                            <img
                                src={payzakat}
                                alt="Pay Zakat"
                                className="img-fluid mt-3"
                                style={{ width: "40%", maxWidth: "400px" }}
                            />
                        </Container>
                    </Col>

                    <Col >
                        <div
                            style={{

                                borderRadius: "10px",
                                padding: "20px",
                                textAlign: "center"
                            }}
                        >
                            <p style={{ fontSize: '20px', marginBottom: '20px', fontWeight: '500' }}>
                                Living in Austin is expensive — please donate generously.
                                Your support helps refugees, single mothers, reverts, the elderly,
                                families with young children, and those without access to education.
                            </p>
                            <a
                                href="/HowItWorks#example-case"
                                style={{
                                    display: "inline-block",
                                    padding: "12px 24px",
                                    backgroundColor: "#3C256B",
                                    color: "white",
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    fontSize: "18px"
                                }}
                            >
                                See How Much It Takes to Support a Family
                            </a>
                        </div>
                    </Col>
                </Row>
            </div>
            <Container className="my-4" >
                <Col
                    className="d-flex flex-column align-items-center justify-content-center text-center px-4"

                >
                    <p style={{ fontSize: "1.4rem", fontWeight: "600", lineHeight: "2rem", direction: "rtl" }}>
                        إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ
                        قُلُوبُهُمْ وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ
                        فَرِيضَةً مِّنَ اللَّهِ وَاللَّهُ عَلِيمٌ حَكِيمٌ
                    </p>
                    <p className="mt-0 py-0 px-1" style={{ fontSize: "1rem" }}>
                        "Zakat expenditures are only for the poor and for the needy and for those employed to collect [zakat],
                        and for bringing hearts together [for Islam], and for freeing captives, and for those in debt, and
                        for the cause of Allah, and for the [stranded] traveler. This is an obligation from Allah,
                        and Allah is All-Knowing, All-Wise." <br /> <em>— Surah At-Tawbah (9:60)</em>
                    </p>
                </Col>
                <hr className="my-4" style={{ height: '2px', backgroundColor: 'black' }} />
                <h4 className="mb-2">Please mark your donation as Zakat or Sadaqah, JazakAllah Khair</h4>
                <Row className="g-2" >
                    {paymentMethods.slice(0, 6).map((method, index) => (
                        <Col xs={12} md={4} key={index}>
                            <div
                                className="d-flex align-items-center p-2 rounded-3 shadow-sm h-100"
                                style={{
                                    border: "3px solid #A4C686",
                                    maxWidth: "450px",
                                    margin: "auto",
                                }}
                            >
                                {method.link ? (
                                    <a href={method.link} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={method.icon}
                                            alt={method.name}
                                            className="me-2"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "20%",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <img
                                        src={method.icon}
                                        alt={method.name}
                                        className="me-3"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "20%",
                                        }}
                                    />
                                )}
                                <div>
                                    {method.link ? (
                                        <a
                                            href={method.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="fw-bold text-primary text-decoration-none"
                                            style={{ fontSize: "20px" }}
                                        >
                                            {method.name}
                                        </a>
                                    ) : (
                                        <span
                                            className="fw-bold text-dark"
                                            style={{ fontSize: "20px" }}
                                        >
                                            {method.name}
                                        </span>
                                    )}
                                    <p className="mb-0">{method.description}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row className="g-2 mt-2">
                    <Col xs={12} md={4}></Col>
                    <Col xs={12} md={4}>
                        <div
                            className="d-flex align-items-center p-2 rounded-3 shadow-sm h-100"
                            style={{
                                border: "3px solid #A4C686",
                                maxWidth: "450px",
                                margin: "auto",
                            }}
                        >
                            <a href={paymentMethods[8].link} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={paymentMethods[8].icon}
                                    alt={paymentMethods[8].name}
                                    className="me-2"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "20%",
                                    }}
                                />
                            </a>
                            <div>
                                <a
                                    href={paymentMethods[8].link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fw-bold text-primary text-decoration-none"
                                    style={{ fontSize: "20px" }}
                                >
                                    {paymentMethods[8].name}
                                </a>
                                <p className="mb-0">{paymentMethods[8].description}</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={4}></Col>
                </Row>


                <Row >
                    <Col xs={12} className="d-flex justify-content-center ">
                        <div
                            className="d-flex align-items-center p-3 rounded-3 shadow-sm w-100 my-2"
                            style={{
                                border: "3px solid #A4C686",
                                maxWidth: "800px",
                                minWidth: '450px',
                                margin: "0 auto",
                                padding: "20px",
                                justifyContent: "center",
                                flexDirection: "row",
                                gap: "20px",
                                marginRight: '4px',
                            }}
                        >
                            <a href="https://causes.benevity.org/user" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={benevity}
                                    alt="Benevity"
                                    className="me-3"
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                    }}
                                />
                            </a>
                            <div style={{ maxWidth: "75%" }}>
                                <a
                                    href="https://causes.benevity.org/user"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fw-bold text-primary text-decoration-none"
                                    style={{ fontSize: "20px" }}
                                >
                                    Company Matching (Benevity)
                                </a>
                                <p className="mb-0">{paymentMethods[6].description}</p>
                            </div>
                        </div>

                       <div
                            className="d-flex align-items-center p-3 rounded-3 shadow-sm w-100 my-2"
                            style={{
                                border: "3px solid #A4C686",
                                maxWidth: "800px",
                                minWidth: '450px',
                                margin: "0 auto",
                                padding: "20px",
                                justifyContent: "center",
                                flexDirection: "row",
                                gap: "20px",
                                marginRight: '4px',
                            }}
                        >
                            <a href="https://causes.benevity.org/user" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={austincares}
                                    alt="Benevity"
                                    className="me-3"
                                    style={{
                                        width: "70px",
                                        height: "50px",
                                    }}
                                />
                            </a>
                            <div style={{ maxWidth: "75%" }}>
                                <a
                                    href="https://causes.benevity.org/user"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fw-bold text-primary text-decoration-none"
                                    style={{ fontSize: "20px" }}
                                >
                                    Company Matching (Austin Cares)
                                </a>
                                <p className="mb-0">{paymentMethods[7].description}</p>
                            </div>
                        </div>
                    </Col>
                </Row>

                <hr className="my-4" style={{ height: '2px', backgroundColor: 'black' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0' }}>
                    <Row>
                        <div style={{ flex: 1, marginRight: '20px' }}>
                            <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Where Does The Zakat Go?</h2>
                            <p style={{ fontSize: '16px', color: '#000' }}>
                                GAMRC helps support vulnerable families in austin by paying for rent,
                                electricity, food and some cases of urgent debts and medical expenses.
                                Provides support to domestic violence cases, single moms, widows, and
                                orphans.  Provides a food basket twice during the blessed month of Ramadan.
                                Operates a space in a low-income complex for refugee kids to attend
                                quran classes and educational programs.
                            </p>
                            <Button
                                href="/WhatWeDo"
                                style={{ backgroundColor: "#42226D", borderColor: "#42226D", width: "200px" }}
                                className="nav-button"
                                target="_blank">
                                What We Do
                            </Button>
                        </div>

                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', maxHeight: '40vh', minHeight: '30vh', marginTop: '0px' }}>
                            <ZakatChart />
                        </div>
                    </Row>
                </div>
            </Container>

            <Footer />
        </div>
    );
};

export default PayZakat;
